module.exports = __webpack_public_path__ + "static/img/home_style1.9f168046.png";